var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5918 6.77712L8.67527 12.6937C7.97173 13.3972 6.83106 13.3972 6.12752 12.6937C5.4225 11.9887 5.42419 10.8451 6.13129 10.1421L10.7194 5.58112L11.8716 4.4289C13.2736 3.02695 15.5466 3.02695 16.9485 4.4289C18.3505 5.83084 18.3505 8.10385 16.9485 9.5058L15.8136 10.6407L11.5124 14.942C9.28744 17.2596 5.91609 17.6123 3.55892 15.3494C1.23061 13.1142 1.62525 9.76315 3.97941 7.40899L8.26372 3.12402",
    stroke: "#8796AF",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachments);
export default __webpack_public_path__ + "static/media/attachments.45b7f0044cbfe025782b14b145184177.svg";
export { ForwardRef as ReactComponent };